import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { Page } from '@interfaces/page';
import { SortingPagingData } from '@helpers/sorting-paging-data';
import { Blacklist } from '../_models/blacklist.model';

const apiServerUrl       = environment.apiBaseURL;
const baseUrl            = apiServerUrl + '/blacklist';
const findByIdUrl        = baseUrl + '/{id}';
const saveUrl            = baseUrl;
const deleteUrl          = baseUrl + '/{id}';
const findPageableUrl    = baseUrl + '/pageable';
const countPageableUrl   = baseUrl + '/pageable-count';

@Injectable({
  providedIn: 'root'
})
export class BlacklistService {

  constructor(private http: HttpClient) { }

  public findById(id: number): Observable<Blacklist> {
    return this.http.get<Blacklist>(findByIdUrl.replace('{id}', `${id}`));
  }

  public save(dto: Blacklist): Observable<number> {
    return this.http.post<number>(saveUrl, dto);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(deleteUrl.replace('{id}', `${id}`));
  }

  public pageable(sortingPaging: SortingPagingData, filters: any): Observable<[Page<Blacklist>, number]> {
    return forkJoin([
      this.findPageable(sortingPaging, filters),
      this.countAll(filters)
    ]);
  }

  public findPageable(sortingPaging: SortingPagingData, filters: any): Observable<Page<Blacklist>> {
    let params = new HttpParams()
      .set('page', sortingPaging.pageNumber.toString())
      .set('pageSize', sortingPaging.pageSize.toString());

    if (filters?.q) params = params.set('q', filters.q);
    if (filters?.channelFilter) params = params.set('channelFilter', filters.channelFilter);
    if (filters?.reason) params = params.set('reason', filters.reason);

    return this.http.get<Page<Blacklist>>(findPageableUrl, { params });
  }

  public countAll(filters: any): Observable<number> {
    let params = new HttpParams();

    if (filters?.q) params = params.set('q', filters.q);
    if (filters?.channelFilter) params = params.set('channelFilter', filters.channelFilter);
    if (filters?.reason) params = params.set('reason', filters.reason);

    return this.http.get<number>(countPageableUrl, { params });
  }
}
